const LOREM_IPSUM_WORDS = [
    'lorem',
    'ipsum',
    'dolor',
    'sit',
    'amet',
    'consectetur',
    'adipiscing',
    'elit',
    'sed',
    'do',
    'eiusmod',
    'tempor',
    'incididunt',
    'ut',
    'labore',
    'et',
    'dolore',
    'magna',
    'aliqua',
];

// ----------------------------------------------------------------------------

export interface LoremIpsumConfig {
    paragraphCount?: number;
    separator?: string;
    wordsPerParagraph?: number;
}

// ----------------------------------------------------------------------------

function loremIpsum(config: number | LoremIpsumConfig = 1): string {
    const paragraphCount = typeof config === 'number' ? config : config.paragraphCount;
    const wordsPerParagraph = typeof config === 'number' ? 20 : (config.wordsPerParagraph ?? 20);
    const separator = typeof config === 'number' ? '\n\n' : (config.separator ?? '\n\n');

    const totalParagraphs = Math.max(0, Math.floor(paragraphCount ?? 1));
    const totalWordsPerParagraph = Math.max(1, Math.floor(wordsPerParagraph));
    const paragraphs: string[] = [];

    for (let p = 0; p < totalParagraphs; p++) {
        let paragraph = '';

        for (let i = 0; i < totalWordsPerParagraph; i++) {
            const randomIndex = Math.floor(Math.random() * LOREM_IPSUM_WORDS.length);
            const word = LOREM_IPSUM_WORDS[randomIndex];

            paragraph += i === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word;
            paragraph += i === totalWordsPerParagraph - 1 ? '.' : ' ';
        }

        paragraphs.push(paragraph);
    }

    return paragraphs.join(separator);
}

// ----------------------------------------------------------------------------

export default loremIpsum;
